import React, { useState, useEffect, useCallback } from 'react';
import './FirstPurgeWarningModal.css';

export default function FirstPurgeWarningModal({
  isOpen,
  onClose,
  onProceed,
  onGoToWhitelist,
  walletAddress,
}) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  // ESC to close (without proceeding)
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose();
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return;
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  const dexScreenerUrl = walletAddress
    ? `https://dexscreener.com/sui/${walletAddress}`
    : 'https://dexscreener.com/sui';

  const handleProceed = () => {
    localStorage.setItem('has_user_purged', 'true');
    if (dontShowAgain) {
      localStorage.setItem('skip_purge_warning', 'true');
    }
    onProceed();
  };

  const handleGoToWhitelist = () => {
    onClose();
    onGoToWhitelist();
  };

  return (
    <div className="fpw-backdrop" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="fpw-modal">

        {/* ── HEADER ── */}
        <div className="fpw-header">
          <div className="fpw-header-icon">🛡️</div>
          <div className="fpw-header-text">
            <p className="fpw-title">First Time Purging? Read This!</p>
            <p className="fpw-subtitle">Takes 2 minutes — could save your valuable tokens</p>
          </div>
        </div>

        {/* ── BODY ── */}
        <div className="fpw-body">

          {/* Warning banner */}
          <div className="fpw-warning-banner">
            <span className="fpw-warning-banner-icon">⚠️</span>
            <p className="fpw-warning-banner-text">
              Purged tokens are <strong>GONE FOREVER</strong> and cannot be recovered.
              Take 2 minutes to protect anything valuable before your first purge.
            </p>
          </div>

          {/* Checklist */}
          <ul className="fpw-checklist">
            <li className="fpw-checklist-item">
              <span className="fpw-check-icon">✅</span>
              Review your wallet on DEX Screener — check USD values of all tokens
            </li>
            <li className="fpw-checklist-item">
              <span className="fpw-check-icon">✅</span>
              Identify anything worth $10+ or with sentimental value
            </li>
            <li className="fpw-checklist-item">
              <span className="fpw-check-icon">✅</span>
              Whitelist those tokens so they're invisible to the purge engine
            </li>
            <li className="fpw-checklist-item">
              <span className="fpw-check-icon">✅</span>
              Then purge safely — your valuables are protected 🛡️
            </li>
          </ul>

          {/* Buttons */}
          <div className="fpw-buttons">
            <a
              href={dexScreenerUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="fpw-btn fpw-btn--dex"
            >
              🔍 Review Wallet on DEX Screener
            </a>
            <button
              className="fpw-btn fpw-btn--whitelist"
              onClick={handleGoToWhitelist}
            >
              🛡️ Go to Whitelist Tab
            </button>
            <button
              className="fpw-btn fpw-btn--proceed"
              onClick={handleProceed}
            >
              ✅ I've Protected Everything — Purge It
            </button>
          </div>

          {/* Don't show again */}
          <div className="fpw-checkbox-row">
            <input
              type="checkbox"
              id="fpw-dont-show"
              className="fpw-checkbox"
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
            />
            <label htmlFor="fpw-dont-show" className="fpw-checkbox-label">
              Don't show this again
            </label>
          </div>

        </div>
      </div>
    </div>
  );
}
